<template>
  <div>
    <DataTable
        :filters="filters"
        :loading="loading"
        :paginator="true"
        :resizableColumns="true"
        :rows="rows"
        :rowsPerPageOptions="[10, 25, 50, 100]"
        :scrollable="true"
        :selection.sync="selection"
        :value="dataRows"
        columnResizeMode="expand"
        selection-mode="multiple"
        style="max-width: 100%!important;"
    >
      <Column :filterFunction="filterBySet" :header="translate('header.type.of.rights')" field="typeOfRight"
              body-style="height: 30px"
              filterField="typeOfRightGuid"
              filterMatchMode="custom">
        <template #filter>
          <Button :label="typeOfRightLabel" class="p-button-secondary" v-on:click="typeOfRightClick"></Button>
        </template>
      </Column>
      <Column :filterFunction="filterBySet" :header="translate('header.territory')" field="licenceTerritory"
              filterField="licenceTerritoryGuid" filterMatchMode="custom">
        <template #filter>
          <Button :label="territoryLabel" class="p-button-secondary" v-on:click="territoryClick"></Button>
        </template>
      </Column>
      <Column :header="translate('header.exclusive')" field="exclusive" filter-match-mode="equals">
        <template #filter>
          <DropDown v-model="filters['exclusive']" :options="exclusiveOptions" appendTo="body"
                    optionLabel="label"
                    optionValue="value"
                    class="p-column-filter"
                    showClear
                    styleClass="ui-column-filter"></DropDown>
        </template>
        <template #body="slotProps">
          {{ exclusiveAsText(slotProps.data.exclusive) }}
        </template>
      </Column>
      <Column :header="translate('header.option')" field="optionAvailable"></Column>

      <Column :header="translate('header.time.windows')">
        <template #body="slotProps">
          <div v-for="ts of slotProps.data.timeSpanList" v-bind:key="ts.start">
            <span class="vertical-span" v-html="renderTimeSpan(ts)"></span>
          </div>
        </template>
      </Column>
      <Column :filterFunction="filterTrafficLights" :header="translate('header.traffic.lights')"
              filterField="trafficLightList"
              filterMatchMode="custom">
        <template #filter>
          <DropDown v-model="filters['trafficLightList']" :options="tlFilterOptions" appendTo="body"
                    optionKey="id" optionLabel="label" styleClass="ui-column-filter"></DropDown>
          <InputText v-model="tlNumber" :placeholder="translate('placeholder.no')" style="width: 30px"></InputText>
        </template>
        <template #body="slotProps">
          <template v-for="tl of slotProps.data.trafficLightList">
            <span v-bind:key="tl.no" class="vertical-span" v-html="renderTrafficLight(tl)"></span>
          </template>
        </template>
      </Column>
      <template #paginatorLeft>
        Count: {{ recordCount }}
      </template>
      <template #empty>
        {{ translate('no.records') }}
      </template>
    </DataTable>

    <Dialog :visible.sync="displayTerritoryFilter" modal>
      <template #header>
        <div>{{ translate('select.territories') }}</div>
      </template>
      <TerritoryTree v-model="filters['licenceTerritoryGuid']"
                     v-on:selectionApplied="territorySelectionApplied"></TerritoryTree>
      <template #footer>
        <div class="p-grid p-justify-between">
          <div class="p-col-9">
            <Button :label="translate('button.clear')" class="p-button-secondary" icon="pi pi-times"
                    v-on:click="cancelClick"/>
            <Button :label="translate('button.apply')" icon="pi pi-check" v-on:click="applyClick"/>
          </div>
        </div>
      </template>
    </Dialog>
    <Dialog :visible.sync="displayTypeOfRightFilter" modal>
      <template #header>
        <div>{{ translate('select.type.of.rights') }}</div>
      </template>
      <TypeOfRightTree v-model="filters['typeOfRightGuid']"
                       v-on:selectionApplied="typeOfRightSelectionApplied"></TypeOfRightTree>
      <template #footer>
        <div class="p-grid p-justify-between">
          <div class="p-col-9">
            <Button :label="translate('button.clear')" class="p-button-secondary" icon="pi pi-times"
                    v-on:click="cancelTypeOfRightsClick"/>
            <Button :label="translate('button.apply')" icon="pi pi-check" v-on:click="applyTypeOfRightsClick"/>
          </div>
        </div>
      </template>
    </Dialog>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {renderDate, renderExclusive} from "./renderer";
import TerritoryTree from "./TerritoryTree";
import TypeOfRightTree from "./TypeOfRightTree";
import TranslateService from "../services/translate.service";

export default {
  name: "AvailDetailsGrid",
  components: {TypeOfRightTree, TerritoryTree},
  props: ['dataRows', 'loading'],
  data() {
    return {
      filters: {},
      selection: [],
      rows: 10,
      tlFilterOptions: [
        {id: 0, label: 'no filter'},
        {id: 1, label: 'Avail', color: 'AVAILABLE'},
        {id: 2, label: 'not avail', color: 'NOT_AVAILABLE'},
        {id: 3, label: 'tba', color: 'TBA'},
      ],
      exclusiveOptions: [
        {value: true, label: "Exclusive"},
        {value: false, label: "Not Exclusive"}
      ],
      tlNumber: null,

      displayTerritoryFilter: false,
      displayTypeOfRightFilter: false,
      typeOfRightLabel: 'no filter',
      territoryLabel: 'no filter'
    }
  },
  methods: {
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    typeOfRightSelectionApplied(selection) {
      this.typeOfRightLabel = selection.displayText;
    },
    territorySelectionApplied(selection) {
      this.territoryLabel = selection.displayText;
    },
    applyTypeOfRightsClick() {
      this.displayTypeOfRightFilter = false;
    },
    cancelTypeOfRightsClick() {
      this.typeOfRightLabel = 'no filter';
      this.filters['typeOfRightGuid'] = null;
      this.displayTypeOfRightFilter = false;
    },
    applyClick() {
      this.displayTerritoryFilter = false;
    },
    cancelClick() {
      this.territoryLabel = 'no filter';
      this.filters['licenceTerritoryGuid'] = null;
      this.displayTerritoryFilter = false;
    },
    territoryClick() {
      this.displayTerritoryFilter = true;
    },
    typeOfRightClick() {
      this.displayTypeOfRightFilter = true;
    },
    filterBySet(value, filter) {
      if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') {
        return true;
      }
      if (value === undefined || value === null) {
        return false;
      }
      if (filter.size === 0) {
        return true;
      }
      return filter.has(value);
    },
    filterTrafficLights(dataFieldValue, filterValue) {
      if (filterValue.id === 0) {
        return true;
      }

      for (let val of dataFieldValue) {
        if ((val.color === filterValue.color) &&
            (this.tlNumber == null || this.tlNumber === '' || this.tlNumber == (val.no + 1))) {
          return true;
        }
      }
      return false;
    },
    renderTimeSpan(timeSpan) {
      let res = '<span class="timespan-display">';
      if (timeSpan.tba) {
        res = '<span class="mf-box-yellow">';
      } else {
        res = '<span>';
      }
      const start = renderDate(timeSpan.start);
      const end = renderDate(timeSpan.end);
      if (timeSpan.exclusive) {
        return res + '<span class="timespan-value">' + start + '-' + end + '</span><span class="timespan-icon"><i class="pi pi-star"></i></span></span></span>'
      } else {
        return res + '<span class="timespan-value">' + start + '-' + end + '</span><span class="timespan-icon"><i class="pi pi-star-o"></i></span></span></span>'
      }
    },
    renderTrafficLight(trafficLight) {
      let res = '';
      if (trafficLight.color === 'AVAILABLE') {
        res = '<span class="mf-box-green">';
      }
      if (trafficLight.color === 'NOT_AVAILABLE') {
        res = '<span class="mf-box-red">';
      }
      if (trafficLight.color === 'TBA') {
        res = '<span class="mf-box-yellow">';
      }
      if (trafficLight.color === 'NOT_RELEVANT') {
        res = '<span class="mf-box-gray">';
      }
      if (trafficLight.color === 'OPTION') {
        res = '<span>';
      }
      if (trafficLight.color === 'INFO') {
        res = '<span>';
      }
      return res + (trafficLight.no + 1) + '</span>';
    },
    exclusiveAsText(isExclusive) {
      return renderExclusive(isExclusive);
    }
  },
  computed: {
    ...mapGetters('nav', ["getContentWidth"]),
    recordCount() {
      return this.dataRows.length;
    },

  }
}
</script>

<style scoped>

</style>